import declare from "dojo/_base/declare";
import QuantityPerSizeMatrix from "./QuantityPerSizeMatrix";

const SCQuantityPerSizeMatrix = declare(QuantityPerSizeMatrix, {
	
	/**
		 * Get size range product sizes
		 */
	getProductSizes(ctx) {
		if (this.productSizes && this.matrixNode == ctx.getNodeContext()) {
			return this.productSizes;
		}

		this.matrixNode = ctx.getNodeContext();
		const sizeRange = ctx.cache.getNode(this.matrixNode.__Parent__);
		this.productSizes = sizeRange ? sizeRange.Sizes : [];
		return this.productSizes;
	},
});
	
export = SCQuantityPerSizeMatrix;